import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import './Support.css';

import destekHeroImage from '../assets/images/destek.jpg';

const Support = () => {
  const faqs = [
    {
      id: 1,
      question: 'ProgenX nedir?',
      answer: 'ProgenX, yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama çözümleri sunan yenilikçi bir teknoloji şirketidir. ODTÜ Teknokent\'te faaliyet göstermektedir.'
    },
    {
      id: 2,
      question: 'Hangi alanlarda yazılım hizmeti veriyorsunuz?',
      answer: 'Web ve mobil uygulama geliştirme, kurumsal yazılım çözümleri, eğitim teknolojileri, IoT ve gömülü sistemler, veri bilimi ve yapay zeka, akıllı raporlama ve analitik çözümleri alanlarında hizmet veriyoruz.'
    },
    {
      id: 3,
      question: 'Yazılım projesi maliyet tahmini nasıl alabilirim?',
      answer: 'Web sitemizdeki Yazılım Maliyet Hesaplayıcı aracımızı kullanarak tahmini maliyet bilgisi alabilirsiniz. Daha detaylı bilgi için iletişim sayfamızdan bize ulaşabilirsiniz.'
    },
    {
      id: 4,
      question: 'Proje geliştirme süreci nasıl işliyor?',
      answer: 'İhtiyaç analizi, planlama, tasarım, geliştirme, test ve dağıtım aşamalarını içeren çevik (agile) metodoloji ile çalışıyoruz. Her aşamada sizinle yakın iletişim halinde oluyoruz.'
    },
    {
      id: 5,
      question: 'Proje sonrası destek sağlıyor musunuz?',
      answer: 'Evet, tüm projelerimiz için bakım ve destek hizmeti sunuyoruz. Hata düzeltmeleri, güncellemeler ve performans optimizasyonları konularında yanınızdayız.'
    }
  ];

  const SupportCard = ({ icon, title, description, buttonText, buttonLink, isExternal }) => {
    const ButtonComponent = isExternal ? 'a' : Link;
    const buttonProps = isExternal 
      ? { href: buttonLink, target: '_blank', rel: 'noopener noreferrer' }
      : { to: buttonLink };
    
    return (
      <div className="support-card">
        <FontAwesomeIcon icon={icon} className="support-card-icon" />
        <h3 className="support-card-title">{title}</h3>
        <p className="support-card-description">{description}</p>
        <ButtonComponent {...buttonProps} className="btn btn-primary">
          {buttonText}
        </ButtonComponent>
      </div>
    );
  };

  return (
    <div className="support">
      <Helmet>
        <title>ProgenX Destek | Yardım Merkezi ve Sıkça Sorulan Sorular 2026</title>
        <meta name="description" content="ProgenX destek sayfası. Sıkça sorulan sorular, yazılım projeleri hakkında bilgi, e-posta ve telefon desteği. Proje süreçleri, maliyet tahmini ve teknik destek hakkında bilgi alın." />
        <meta name="keywords" content="progenx destek, progenx yardım, progenx sss, yazılım projesi destek, progenx müşteri hizmetleri, progenx iletişim, progenx teknik destek" />
        <meta property="og:title" content="ProgenX Destek | Yardım Merkezi" />
        <meta property="og:description" content="ProgenX müşterileri için kapsamlı destek merkezi. Sıkça sorulan sorular ve iletişim seçenekleri." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/destek" />
        <link rel="canonical" href="https://progenx.com.tr/destek" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="DESTEK" 
        backgroundImage={destekHeroImage}
      />
      
      <section className="support-content">
        <div className="container">
          <h2 className="section-title">Size Nasıl Yardımcı Olabiliriz?</h2>
          <p className="support-intro">
            ProgenX müşterilerine en iyi destek hizmetini sunmak için buradayız. Aşağıdaki seçeneklerden ihtiyacınıza uygun olanı seçebilirsiniz.
          </p>
          
          <div className="support-cards">
            <SupportCard 
              icon={faQuestionCircle}
              title="Sıkça Sorulan Sorular"
              description="Sık sorulan sorular ve cevapları ile hızlıca çözüm bulun"
              buttonText="SSS'lere Göz Atın"
              buttonLink="#faq-section"
            />
            
            <SupportCard 
              icon={faEnvelope}
              title="E-posta Desteği"
              description="Sorularınız için bize e-posta gönderin, en kısa sürede yanıtlayalım"
              buttonText="E-posta Gönder"
              buttonLink="/iletisim"
            />
            
            <SupportCard 
              icon={faPhone}
              title="Telefon Desteği"
              description="Hafta içi 09:00-18:00 saatleri arasında bize ulaşabilirsiniz"
              buttonText="Bizi Arayın"
              buttonLink="tel:+905386864516"
              isExternal={true}
            />
          </div>
          
          <section id="faq-section" className="faq-section">
            <h3 className="faq-section-title">Sıkça Sorulan Sorular</h3>
            
            <div className="faq-list">
              {faqs.map(faq => (
                <div key={faq.id} className="faq-item">
                  <h4 className="faq-question">
                    <FontAwesomeIcon icon={faQuestionCircle} className="faq-question-icon" />
                    {faq.question}
                  </h4>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              ))}
            </div>
          </section>
          
          <div className="support-cta">
            <h3 className="support-cta-title">Sorunuzu Bulamadınız mı?</h3>
            <p className="support-cta-text">Daha kapsamlı destek için bizimle iletişime geçebilirsiniz.</p>
            <Link to="/iletisim" className="btn btn-primary">İLETİŞİME GEÇ</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Support;
